import { timeFix } from '@/utils/util';
import ls from '@/utils/Storage';
import { ACCESS_TOKEN, PERMISSION, USER_INFO } from '@/store/mutation-types';
import { message, notification } from 'ant-design-vue';
import { Router } from 'vue-router'
import { getSmsCaptcha } from './service'
import api from '@/utils/http/service'
import {mqttstart} from '@/utils/mqttclient'

import config from '@/config/defaultSettings'
import {generateAsyncRoutes1} from '@/router/generateAsyncRoutes'

export const loginSuccess = (res, router: Router,app:ComponentInternalInstance) => {
  // 延迟 1 秒显示欢迎信息
  setTimeout(() => {
    notification.success({
      message: '欢迎',
      description: `${timeFix()}，欢迎回来`,
    });
  });
  if (res.token) {
    ls.set(ACCESS_TOKEN, res.token, 7 * 24 * 60 * 60 * 1000);
    ls.set(USER_INFO, res.user);
    ls.set(PERMISSION,res.permissions);
    mqttstart(res.user.userid,app)
    generateAsyncRoutes1(router) //加载用户菜单
    window.location.href = '/dashboard'
  }

  //router.push({ path: '/admin' });
};

export const requestFailed = (err) => {
  notification['error']({
    message: '错误',
    description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
    duration: 4,
  });
};

export const useGetCaptcha = (e, validate, state, form, registerBtn) => {
  e.preventDefault();
  validate(['mobile']).then((res) => {
    state.smsSendBtn = true;
    const interval = window.setInterval(() => {
      if (state.time-- <= 0) {
        state.time = 60;
        state.smsSendBtn = false;
        window.clearInterval(interval);
      }
    }, 1000);

    message.loading('验证码发送中..', 1);
    api.user.yzm({pnone:form.mobile}).then((res) => {
        if(res.state==1){
            notification['success']({
            message: '提示',
            description: '验证码获取成功，您的验证码为：' + res.result.captcha,
            duration: 8,
          });
        }
      })
      .catch((err) => {
        clearInterval(interval);
        state.time = 60;
        state.smsSendBtn = false;
        requestFailed(err);
        registerBtn && (registerBtn.value = false);
      });
  });
};
